import { useContext } from "react";
import { OrganizationContext } from "common/providers/OrganizationProvider";

export const useOrganization = () => useContext(OrganizationContext);

export default useOrganization;
